$(document).ready(function() {

    var decalFrame = Snap("#decalFrame");
    var maxWidth = 272.6;
    var padding = 4.5;
    var testTextWidth;
    var inputText;
    var inputFont;
    var inputLeftFlag;
    var leftFlagWidth;
    var decalTextWidth;
    var rightFlagWidth;
    var rightFlagTransform;
    var textWidth;
    var decalWidth;
    var innerWidth;
    var leftFlagX;
    var textX;
    var rightFlagX;
    var p = decalFrame.circle(0.5,0.5,0.5).attr({
        fill: "#D3D3D3",
    });
    p = p.toPattern(0, 0, 2, 2);
    //Set Default Decal

    var background = decalFrame.rect(49.94, 1.5, 178.9, 36, padding,
        padding);

    background.attr({
        fill: "#000000",
        "stroke": "#000000",
        "stroke-width": "0.5"
    });

    var leftFlag = decalFrame.group();
    leftFlag.attr({
        "class": "leftFlag"
    });
    leftFlag.transform("T54.44,6");

    Snap.load(
        "//cdn.shopify.com/s/files/1/0112/4282/t/30/assets/flag-heart.svg?5132137115917087679",
        onSVGLoaded);

    function onSVGLoaded(data) {
        var flagGroup = data.selectAll("g");
        leftFlag.append(flagGroup);
    }

    var decalText = decalFrame.text(88.54, 27, "Your Name");
    var testText = decalFrame.text(88.54, 27, "Your Name");
    decalText.attr({
        fill: "#fff",
        "font-size": 26,
        "font-family": "Fugaz One"
    });
    testText.attr({
        fill: "#fff",
        "font-size": 26,
        "font-family": "Fugaz One",
        "visibility": "hidden"
    });

    var rightFlag = decalFrame.group();
    rightFlag.attr({
        "class": "right-flag"
    });
    rightFlag.transform("T6,6");

    // Set Text

    $("input[name='properties[Text]']").on("keyup", setText);

    function setText() {
        inputText = $("input[name='properties[Text]']").val();
        testText.attr({
            text: inputText
        });
        decalText.attr({
            text: inputText
        });
        resize();
        setDecalWidth();
        setSize();
    }

    // Set Font
    $("select[name='properties[Font]']").val("Fugaz One");
    $("select[name='properties[Font]']").on("change", setFont);

    function setFont() {
        inputFont = $("select[name='properties[Font]']").val();
        testText.attr({
            "font-family": inputFont
        });
        decalText.attr({
            "font-family": inputFont
        });
        if (inputFont == "Amatic SC") {
            decalText.attr({
                y: 28,
                "font-size": 26
            });
        } else if (inputFont == "Cinzel") {
            decalText.attr({
                y: 28,
                "font-size": 26
            });
        } else if (inputFont == "Fugaz One") {
            decalText.attr({
                y: 27,
                "font-size": 26
            });
        } else if (inputFont == "Great Vibes") {
            decalText.attr({
                y: 25,
                "font-size": 23
            });
        } else if (inputFont == "Molle") {
            decalText.attr({
                y: 28,
                "font-size": 26
            });
        } else if (inputFont == "Montserrat") {
            decalText.attr({
                y: 28,
                "font-size": 26
            });
        } else if (inputFont == "Open Sans Condensed") {
            decalText.attr({
                y: 28,
                "font-size": 26
            });
        } else if (inputFont == "Permanent Marker") {
            decalText.attr({
                y: 28,
                "font-size": 26
            });
        } else if (inputFont == "PT Serif") {
            decalText.attr({
                y: 28,
                "font-size": 26
            });
        } else if (inputFont == "Righteous") {
            decalText.attr({
                y: 28,
                "font-size": 26
            });
        } else if (inputFont == "Shrikhand") {
            decalText.attr({
                y: 28,
                "font-size": 26
            });
        } else if (inputFont == "Squada One") {
            decalText.attr({
                y: 28,
                "font-size": 29
            });
        }
      background.animate({width: maxWidth},500); 
      background.animate({x:140-maxWidth/2},500);
        setTimeout(resize, 500);
        setTimeout(setDecalWidth, 500);
        setTimeout(setSize, 500);
    }

    // Set Left Flag
    $("#leftFlag").on("change", setLeftFlag);

    function setLeftFlag() {
        $(".leftFlag").empty();
        inputLeftFlag = $("#leftFlag").val();
        var inputFlagName = $("#leftFlag option:selected").text();
        $("input[name='properties[Left Flag]']").val(inputFlagName);
        if (inputLeftFlag != "None") {
            Snap.load(inputLeftFlag, onSVGLoaded);

            function onSVGLoaded(data) {

                var flagGroup = data.selectAll("g");
                leftFlag.append(flagGroup);
                resize();
                setDecalWidth();
            }
        } else {
            resize();
            setDecalWidth();
        }
    }

    // Set Right Flag

    $("#rightFlag").on("change", setRightFlag);

    function setRightFlag() {
        $(".right-flag").empty();
        inputRightFlag = $("#rightFlag").val();
        var inputFlagName = $("#rightFlag option:selected").text();
        $("input[name='properties[Right Flag]']").val(inputFlagName);
        if (inputRightFlag != "None") {
            Snap.load(inputRightFlag, onSVGLoaded);

            function onSVGLoaded(data) {
                var flagGroup = data.selectAll("g");
                rightFlag.append(flagGroup);
                resize();
                setDecalWidth();
            }
        } else {
            resize();
            setDecalWidth();
        }
    }

    // Set Background Color
    $("#backgroundColor").val("#000000");
    $("#backgroundColor").on("change", setColor);

    function setColor() {
        var inputColor = $("#backgroundColor").val();
        var inputColorName = $("#backgroundColor option:selected").text();
        $("input[name='properties[Background Color]']").val(
            inputColorName);
        if (inputColor == "transparent") {
            background.attr({
                fill: p,
                "stroke": "#f6f6f6",
            })
        } else if (inputColor == "#FFFFFF") {
            background.attr({
                fill: inputColor,
                "stroke": "#f6f6f6",
            })
        } else {
            background.attr({
                fill: inputColor,
                "stroke": inputColor,
            })
        }
      setTimeout(setData, 100);
    }

    // Set Text Color

    //Set Color
    $("#textColor").val("#FFFFFF");
    $("#textColor").on("change", setTextColor);

    function setTextColor() {
        var inputColor = $("#textColor").val();
        var inputColorName = $("#textColor option:selected").text();
        $("input[name='properties[Text Color]']").val(inputColorName);
        decalText.attr({
            fill: inputColor
        });
            setTimeout(setData, 100);
    }

    // Spacing and Sizing

    function resize() {
        testTextWidth = testText.getBBox().width;
        leftFlagWidth = leftFlag.getBBox().width;
        rightFlagWidth = rightFlag.getBBox().width;

        if (leftFlagWidth > 0 && rightFlagWidth > 0) {
            if (testTextWidth + leftFlagWidth + rightFlagWidth +
                padding * 4 > maxWidth) {
                decalText.attr({
                    "textLength": maxWidth - leftFlagWidth -
                        rightFlagWidth - padding * 4,
                    "lengthAdjust": "spacingAndGlyphs"
                });
            } else {
                decalText.attr({
                    "textLength": ""
                })
            }
        } else if (leftFlagWidth > 0 || rightFlagWidth > 0 && !(
                leftFlagWidth > 0 && rightFlagWidth > 0)) {
            if (testTextWidth + leftFlagWidth + rightFlagWidth +
                padding * 3 > maxWidth) {
                decalText.attr({
                    "textLength": maxWidth - leftFlagWidth -
                        rightFlagWidth - padding * 3,
                    "lengthAdjust": "spacingAndGlyphs"
                });
            } else {
                decalText.attr({
                    "textLength": ""
                })
            }
        } else {
            if (testTextWidth + leftFlagWidth + rightFlagWidth +
                padding * 2 > maxWidth) {
                decalText.attr({
                    "textLength": maxWidth - leftFlagWidth -
                        rightFlagWidth - padding * 2,
                    "lengthAdjust": "spacingAndGlyphs"
                });
            } else {
                decalText.attr({
                    "textLength": ""
                })
            }
        }
    }

    function setDecalWidth() {
        leftFlagWidth = leftFlag.getBBox().width;
        textWidth = decalText.getBBox().width;
        rightFlagWidth = rightFlag.getBBox().width;

        if (leftFlagWidth > 0 && rightFlagWidth > 0) {
            decalWidth = padding * 4 + leftFlagWidth + textWidth +
                rightFlagWidth;
            textX =  140-decalWidth/2 + padding*2 + leftFlagWidth;
            rightFlagX =  140-decalWidth/2 + padding*3 + leftFlagWidth + textWidth;
        } else if (leftFlagWidth > 0 && rightFlagWidth == 0) {
            decalWidth = padding * 3 + leftFlagWidth + textWidth;
            textX =  140-decalWidth/2 + padding*2 + leftFlagWidth;
        } else if (leftFlagWidth == 0 && rightFlagWidth > 0) {
            decalWidth = padding * 3 + rightFlagWidth + textWidth;
            textX =  140-decalWidth/2 + padding;
            rightFlagX =  140-decalWidth/2 + padding*2 + textWidth;
        } else {
            decalWidth = padding * 2 + leftFlagWidth + textWidth;
            textX =  140-decalWidth/2 + padding;
        }
      
      leftFlagX =  140-decalWidth/2 + padding;
      leftFlagX = "T" + leftFlagX + ",6";
      rightFlagX = "T" + rightFlagX + ",6";
      
      decalText.animate({x:textX},250);
      leftFlag.animate({transform:leftFlagX},250);
      rightFlag.animate({transform:rightFlagX},250);
      background.animate({width: decalWidth},250,mina.bounce); 
      background.animate({x:140-decalWidth/2},250,mina.bounce);
      setTimeout(setData, 300);
    }

    // Size Calculator

    function setSize() {
        if ($("select[name='id']").val() == 35863580618 || $("select[name='id']").val() == 36204449738 || $("select[name='id']").val() == 36204589386 ) {
            var decalheight = 0.5;
        } else if ($("select[name='id']").val() == 35863580682 || $("select[name='id']").val() == 36204488586 || $("select[name='id']").val() == 36204449802 ) {
            var decalheight = 0.75;
        } else if ($("select[name='id']").val() == 35863580746 || $("select[name='id']").val() == 36204449930 || $("select[name='id']").val() == 36204488650 ) {
            var decalheight = 1;
        }
        var pixelwidth = background.getBBox().width;
        var decalwidth = ((pixelwidth * decalheight) / 36).toFixed(2);
        $("input[name='properties[Width]']").val(decalheight + '"' + " x " + decalwidth + '"');
    }

    setInterval(setSize, 1000);

    // Set Data

    function setData() {
        var codeBlock = $('#svg-container').html();
        codeBlock = window.btoa(codeBlock);
        var dataHolder = $("#data");
        dataHolder.val(codeBlock);
    }

});